var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconKey = function SvgIconKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-key_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    d: "M17.357 5.787a.643.643 0 0 0-.642.642v1.928h-1.928V6.43a.643.643 0 1 0-1.286 0v1.928H7.66a3.856 3.856 0 1 0 0 1.286h9.698A.643.643 0 0 0 18 9V6.43a.643.643 0 0 0-.643-.643M3.861 11.57a2.57 2.57 0 1 1 0-5.142 2.57 2.57 0 0 1 0 5.142"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-key_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v18H0z"
  })))));
};
export default SvgIconKey;